import Axios from '../baseApi';

export default {
  async fetchAll() {
    return await Axios.get('api-master-data/pig-price-categories/v1');
  },
  async fetchCategories() {
    return await Axios.get('api-master-data/pig-price-categories/v1/categories');
  },
  async fetchCalendar() {
    return await Axios.get('api-master-data/pig-calendar-categories/v1');
  }
}
